export default {
    ALL_LINKS: 0,
    NEW_LINKS: 1,
    LOST_LINKS: 2,
};
